<div class="flex flex-col">
  @if (displayLoader()) {
    <mat-progress-bar color="accent" mode="indeterminate" />
  }
  <oyan-ui-chart-filter [defaultChartPeriod]="CHART_PERIOD_CONSTANTS.DEFAULT_DAYS" (dataRangeChange)="dataRangeChange($event)" />
  <highcharts-chart [options]="chartOptions()" [oneToOne]="true" (chartInstance)="onChartCreated($event)" class="display-block h-full w-full" />
</div>
